import type { AuthAction, AuthState } from '../Auth.types';

const authReducer = (prevState: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      return {
        state: 'loggedin',
        loading: false,
        error: undefined,
        isLoggingOut: false,
        user: action.payload.user,
        //profile: undefined,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        csrfToken: action.payload.csrfToken,
      };

    case 'SET_USER':
      return {
        ...prevState,
        user: action.payload.user,
      };

    case 'SET_PROFILE':
      return {
        ...prevState,
        //profile: action.payload.profile,
      };

    case 'LOGOUT':
      return {
        ...prevState,
        state: 'loggedout',
        loading: false,
        error: undefined,
        user: undefined,
        //profile: undefined,
        accessToken: undefined,
        refreshToken: undefined,
        csrfToken: undefined,
      };

    case 'BROADCASTING_LOGOUT':
      return {
        ...prevState,
        isLoggingOut: action.payload.loading,
      };

    case 'SET_LOADING':
      return {
        ...prevState,
        loading: action.payload.loading,
      };

    case 'REVALIDATE_TOKENS':
      return {
        ...prevState,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        csrfToken: action.payload.csrfToken,
      };

    case 'SET_ERROR':
      return {
        ...prevState,
        error: action.payload.message,
      };
    default:
      return prevState;
  }
};

export default authReducer;
